export default "__VITE_ASSET__D0hJ2L0U__"